// src/pages/admin/auth/Login.jsx
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  FiUser,
  FiLock,
  FiEye,
  FiEyeOff,
  FiShield,
  FiArrowRight,
} from "react-icons/fi";
import { GiFarmTractor } from "react-icons/gi";
import axios from "axios";
import "../../../assets/css/superadmin/adminlogin/Auth.css";
import AppContext from "../../../context/AppContext";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { baseUrl, setAuthToken } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errormessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const Login = () => {
    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("password", password);
    axios
      .post(`${baseUrl}/superadmin/authentication/superadminlogin`, formdata)
      .then((response) => {
        if (!response.data.token) {
          setErrorMessage("Invalid Email and Password");
        } else {
          console.log("LOGIN SUCCESSFULLY", response.data);
          localStorage.setItem("adminEmail", email);
          localStorage.setItem("adminPassword", password);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);

          localStorage.setItem(
            "LoggedInAdmin",
            JSON.stringify(response.data.superadmin),
          );

          navigate("/admin/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Login failed. Please check your credentials.");
      });
  };

  const autoLogin = (savedEmail, savedPassword) => {
    const formdata = new FormData();
    formdata.append("email", savedEmail);
    formdata.append("password", savedPassword);
    axios
      .post(`${baseUrl}/superadmin/authentication/superadminlogin`, formdata)
      .then((response) => {
        console.log(response.data);
        if (!response.data.token) {
          localStorage.removeItem("adminEmail");
          localStorage.removeItem("adminPassword");
          setErrorMessage(response.data.error);
        } else {
          console.log("LOGIN SUCCESSFULLY", response.data);
          localStorage.setItem("adminEmail", savedEmail);
          localStorage.setItem("adminPassword", savedPassword);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          console.log(response.data.token);

          navigate("/admin/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
        localStorage.removeItem("adminEmail");
        localStorage.removeItem("adminPassword");
      });
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem("adminEmail");
    const savedPassword = localStorage.getItem("adminPassword");
    if (savedEmail && savedPassword) {
      autoLogin(savedEmail, savedPassword);
    }
  }, []);

  return (
    <div className="admin-login-page">
      {/* Animated Background */}
      <div className="login-background">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-shape shape-3"></div>

        {/* Floating Tyres */}
        <div className="floating-tyres">
          <div className="tyre tyre-1">
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
          </div>
          <div className="tyre tyre-2">
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
          </div>
          <div className="tyre tyre-3">
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
          </div>
          <div className="tyre tyre-4">
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
          </div>
          <div className="tyre tyre-5">
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
            <div className="tyre-spoke"></div>
          </div>
        </div>
      </div>

      {/* Login Container */}
      <div className="login-container">
        <div className="login-card">
          {/* Logo Section */}
          <div className="login-logo">
            <div className="logo-icon">
              <GiFarmTractor size={40} />
            </div>
          </div>

          {/* Header */}
          <div className="login-header">
            <h1 className="login-title">Smart Agri Rent</h1>
            <p className="login-subtitle">Super Admin Portal</p>
          </div>

          {/* Login Form */}
          <form className="login-form">
            {/* Username Field */}
            <div className="auth-form-group">
              <label className="auth-form-label">ENTER YOUR EMAIL </label>
              <div className="auth-input-wrapper">
                {/* <FiUser className="auth-input-icon" /> */}
                <input
                  type="text"
                  name="username"
                  className={`form-input ${errormessage.username ? "error" : ""}`}
                  placeholder="admin_access"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  disabled={isLoading}
                />
              </div>
              {errormessage.username && (
                <span className="error-message">{errormessage.username}</span>
              )}
            </div>

            {/* Password Field */}
            <div className="auth-form-group">
              <div className="label-row">
                <label className="auth-form-label">PASSWORD</label>
                {/* <button
                  type="button"
                  className="forgot-link"
                  onClick={handleForgotPassword}
                  disabled={isLoading}
                >
                  Forgot Password?
                </button> */}
              </div>
              <div className="auth-input-wrapper">
                {/* <FiLock className="auth-input-icon" /> */}
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className={`form-input ${errormessage.password ? "error" : ""}`}
                  placeholder="••••••••"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  disabled={isLoading}
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={isLoading}
                >
                  {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                </button>
              </div>

              <p style={{ textAlign: "right", marginTop: "8px" }}>
                <span
                  onClick={() =>
                    navigate("/general/forgot-password/superadmin")
                  }
                  style={{
                    color: "#FDB714",
                    fontWeight: "600",
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontSize: "0.85rem",
                  }}
                >
                  Forgot Password?
                </span>
              </p>

              {errormessage.password && (
                <span className="error-message">{errormessage.password}</span>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="button"
              className="login-button"
              onClick={Login}
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="button-loading">
                  <span className="spinner"></span>
                  Logging in...
                </span>
              ) : (
                <>
                  Login to Dashboard
                  <FiArrowRight size={18} />
                </>
              )}
            </button>
          </form>

          {/* Security Badge */}
          <div className="security-badge">
            <FiShield className="shield-icon" />
            <span>ENCRYPTED SECURITY SESSION</span>
          </div>

          {/* Footer */}
          <div className="login-footer">
            <p>© 2025 SMART AGRICULTURAL MANAGEMENT</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
